import type { SessionData, SessionType } from '../types';
import { Storage } from './storage.ts';
import { uid } from './id.ts';

const SESSION_KEY = 'kf-session-state';
const LEGACY_SESSION_KEY = 'kairofocus_session';

const migrateIfNeeded = (): void => {
  if (!localStorage.getItem(SESSION_KEY) && localStorage.getItem(LEGACY_SESSION_KEY)) {
    const raw = localStorage.getItem(LEGACY_SESSION_KEY)!;
    localStorage.setItem(SESSION_KEY, raw);
    localStorage.removeItem(LEGACY_SESSION_KEY);
  }
};

export const getNextSessionId = (sessionType: SessionType): string => {
  migrateIfNeeded();
  const id = uid();
  Storage.write<SessionData>(SESSION_KEY, {
    currentSessionId: id,
    lastSessionStart: Date.now(),
    sessionType,
  });
  return id;
};

export const getCurrentSessionData = (): SessionData | null => {
  migrateIfNeeded();
  return Storage.read<SessionData | null>(SESSION_KEY, null);
};

export const clearCurrentSession = (): void => {
  Storage.write(SESSION_KEY, null);
};

export const clearSessionData = (): void => {
  Storage.remove(SESSION_KEY);
};
